export default __webpack_public_path__ + "static/media/FinTechAwards.72f1a3c9.png";